import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
export const fetchConditionalPropertyRules = (objectTypeId, httpClient, options) => {
  return getFrameworkDataSchemasClient({
    httpClient
  }).then(client => {
    var _options$includeAssoc;
    return client.conditionalPropertyRules.get({
      frameworkTypeIdentifier: objectTypeId,
      query: {
        includeAssociationFields: (_options$includeAssoc = options === null || options === void 0 ? void 0 : options.includeAssociationFields) !== null && _options$includeAssoc !== void 0 ? _options$includeAssoc : false
      }
    });
  });
};